import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    productBannerDetails: {
        name: "",
        content: "",
        status: true,
    },
    modal: false,
    edit: false,
    productBanners: [], 
    loading: false,
    activeStatus: [],
    searchProductBanner: ""
};

const productBannerReducer = createSlice({
    name: "productBannerReducer",
    initialState: initialState,
    reducers: {
        updateProductBannerDetails: (state, { payload }) => {
            state.productBannerDetails = payload;
        },
        updateModal: (state, { payload }) => {
            state.modal = payload;
        },
        updateLoadingProductBanners: (state, { payload }) => {
            state.loading = payload;
        },
        updateProductBanners: (state, { payload }) => {
            state.productBanners = payload;
        },
        updateActiveStatus: (state, { payload }) => {
            state.activeStatus = payload;
        },
        updateEdit: (state, { payload }) => {
            state.edit = payload;
        },
        updateSearchProductBanner: (state, { payload }) => {
            state.searchProductBanner = payload;
        },
    }
});

export const { 
    updateModal, 
    updateProductBannerDetails, 
    updateLoadingProductBanners, 
    updateProductBanners, 
    updateActiveStatus, 
    updateEdit, 
    updateSearchProductBanner 
} = productBannerReducer.actions;

export default productBannerReducer.reducer;
